var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconDrag = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 8,
  height: 8,
  viewBox: "0 0 8 8",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_1243",
  "data-name": "Group 1243",
  transform: "translate(-253 -272)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2545",
  "data-name": "Path 2545",
  d: "M10.2,16.4a1.6,1.6,0,1,1-1.6-1.6A1.6,1.6,0,0,1,10.2,16.4ZM8.6,10a1.6,1.6,0,1,0,1.6,1.6A1.6,1.6,0,0,0,8.6,10Zm4.8,0A1.6,1.6,0,1,0,15,11.6,1.6,1.6,0,0,0,13.4,10Zm0,4.8A1.6,1.6,0,1,0,15,16.4,1.6,1.6,0,0,0,13.4,14.8Z",
  transform: "translate(246 262)",
  fill: "#e2e2e2"
}))));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconDrag, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_drag.521fe40b.svg";
export { ForwardRef as ReactComponent };